<template>
    <component :is="tag" :class="['text-black font-medium', getCssStyle]">
        <slot />
    </component>
</template>

<script lang="ts" setup>
    import { HEADING_TAG } from '@shc/nuxt-shc-ui-layer/components/Heading/heading'
    import type { Props } from './props'

    const props = withDefaults(defineProps<Props>(), {
        size: HEADING_TAG.h1,
    })

    const getCssStyle = computed(() => {
        switch (props.size) {
            case HEADING_TAG.h2:
                return 'text-lg leading-5'
            case HEADING_TAG.h3:
                return 'text-base leading-5'
            case HEADING_TAG.h4:
                return 'text-sm leading-4'
            case HEADING_TAG.h5:
                return 'text-xs leading-4'
            default:
                return 'text-xl leading-6'
        }
    })
</script>
